import DynamicComponentBaseProps from "features/shared/components/dynamicComponetWrapper/DynamicComponentBaseProps";
import IAppState from "infrastructure/store/IAppState";
import ContractsCountState from "infrastructure/store/contractsCount/ContractsCountState";
import React from "react";
import { useSelector } from "react-redux";
import TopBarCommodityIcon from "./TopBarCommodityIcon";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import TopBarIcon from "./TopBarIcon";
import { TopbarCommodityItem } from "features/shared/models/TopBarCommodityItem";

interface Props extends DynamicComponentBaseProps {}

const TopBarIconsTeplarnyBrno = (props: Props) => {
  // store
  const contractsCount = useSelector<IAppState, ContractsCountState>(
    (store) => store.contractsCount
  ).contractsCount;

  const icons: TopbarCommodityItem[] = [
    { commodityDetail: "HeatCustomer", isProduction: false },
    { commodityDetail: "ElectricityCustomer", isProduction: false },
    { commodityDetail: "ElectricityCustomer", isProduction: true },
    { commodityDetail: "GasCustomer", isProduction: false },
    { commodityDetail: "eMobility", isProduction: false },
  ];

  // sub-renders
  const renderCommodityIcons = () => {
    if (contractsCount.length > 0) {
      return contractsCount.map((item, index) =>
        renderCommodityIcon(item.commodityDetail!, !!item.isProduction, item.count!, index));
    } else {
      return icons.map((item, index) =>
        renderCommodityIcon(item.commodityDetail, item.isProduction, 0, index));
    }
  };

  const renderCommodityIcon = (
    commodityDetail: CommodityDetail,
    isProduction: boolean,
    contractCount: number,
    index: number
  ) => {
    return (
      <TopBarCommodityIcon
        commodityDetail={commodityDetail}
        isProduction={isProduction}
        active={contractCount > 0}
        key={index}
      />
    );
  };

  // render
  return (
    <div className="d-none d-xl-flex align-items-center ml-3">
      {renderCommodityIcons()}
      <TopBarIcon iconName="cold" />
      <TopBarIcon iconName="hydrogen" iconSize={1.45} />
      <TopBarIcon iconName="services" />
    </div>
  );
};

export default TopBarIconsTeplarnyBrno;
